import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { DashboardRoute } from "@/routes/dashboard";
import AppContext from "@/App/context/AppContext";
import { GetRequest } from "@/api/RequestTemplates";

import { useMutation, useQueryClient } from "react-query";
import { LoginRoute } from "@/routes/auth";

async function getUserTokenFromLoginLinkToken(token: string) {
  return GetRequest(`${process.env.API_SERVER_URL}/users/verify-login-token?token=${token}`);
}

function Passwordless() {
  const { search } = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(search);
  //const name = searchParams.get("name");
  const token = searchParams.get("token");
  const { setLoggedIn } = useContext(AppContext);
  const queryClient = useQueryClient();

  const mutation = useMutation((token: string | undefined) => getUserTokenFromLoginLinkToken(token ?? ""), {
    onSuccess: (data) => {
      switchUser(data);
      setTimeout(() => {
        queryClient.invalidateQueries("userQuery");
      }, 500);
    },
    onError: (error) => {
      console.error("Error while verifying login token", error);
      navigate(LoginRoute + "?linkExpired=true");
    },
  });

  const handleSubmit = () => {
    mutation.mutate(token ?? undefined);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const switchUser = (data: any) => {
    const afterLoginRedirectUrl = searchParams.get("afterLoginRedirectURL")?.replace(/"/g, "");
    setLoggedIn && setLoggedIn(false);

    const keysToDelete = [
      "access_token",
      "auto_login_token",
      "client_id",
      "expires_in",
      "gtmInitialized",
      "jti",
      "refresh_token",
      "scope",
      "token_type",
      "user_id",
    ];

    keysToDelete.forEach((key) => {
      localStorage.removeItem(key);
    });

    const datatemp = data.data;

    // Iterate over the key-value pairs in the data object and set them in localStorage
    for (const [key, value] of Object.entries(datatemp)) {
      localStorage.setItem(key, String(value));
    }

    console.log(DashboardRoute);
    setLoggedIn && setLoggedIn(true);
    setTimeout(() => {
      if (afterLoginRedirectUrl) {
        navigate(afterLoginRedirectUrl);
      } else {
        navigate(DashboardRoute);
      }
    }, 1000);
  };

  useEffect(() => {
    handleSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  return null; // No need to return anything since we no longer have a form to render
}

export default Passwordless;
